import { render, staticRenderFns } from "./legal_agreement_list.vue?vue&type=template&id=d1afc9da&scoped=true"
import script from "./legal_agreement_list.vue?vue&type=script&lang=js"
export * from "./legal_agreement_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1afc9da",
  null
  
)

export default component.exports